import { useState } from 'react';
import UnsplashImagePicker from './UnsplashImagePicker';
import ImageUploadField from './ImageUploadField';

/**
 * Unified image selector - toggle between Unsplash search or manual upload
 * 
 * @param {Function} onImageSelect - Callback with selected image data
 * @param {Object} currentImage - Current image: { type: 'unsplash' | 'upload', unsplashPhoto?, uploadUrl?, caption? }
 * @param {string} defaultQuery - Default Unsplash search query
 */
export default function ImageSelector({ onImageSelect, currentImage = null, defaultQuery = '' }) {
  const [imageSource, setImageSource] = useState(currentImage?.type || 'unsplash'); // 'unsplash' or 'upload'

  const handleUnsplashSelect = (photo) => {
    onImageSelect({
      type: 'unsplash',
      unsplashPhoto: photo,
      url: photo.urls.regular
    });
  };

  const handleUpload = (uploadData) => {
    if (uploadData) {
      onImageSelect({
        type: 'upload',
        uploadUrl: uploadData.url,
        caption: uploadData.caption,
        url: uploadData.url
      });
    } else {
      onImageSelect(null);
    }
  };

  return (
    <div className="space-y-4">
      {/* Toggle Buttons */}
      <div className="flex gap-3 p-1 bg-gray-100 rounded-xl">
        <button
          type="button"
          onClick={() => setImageSource('unsplash')}
          className={`
            flex-1 py-2 px-4 rounded-lg font-semibold transition-all
            ${imageSource === 'unsplash'
              ? 'bg-white text-primary shadow-sm'
              : 'text-text-secondary hover:text-text-primary'
            }
          `}
        >
          🔍 Search Unsplash
        </button>
        <button
          type="button"
          onClick={() => setImageSource('upload')}
          className={`
            flex-1 py-2 px-4 rounded-lg font-semibold transition-all
            ${imageSource === 'upload'
              ? 'bg-white text-primary shadow-sm'
              : 'text-text-secondary hover:text-text-primary'
            }
          `}
        >
          📤 Upload Image
        </button>
      </div>

      {/* Content */}
      <div className="min-h-[400px]">
        {imageSource === 'unsplash' ? (
          <UnsplashImagePicker
            onSelect={handleUnsplashSelect}
            initialQuery={defaultQuery}
            selectedPhoto={currentImage?.unsplashPhoto}
          />
        ) : (
          <ImageUploadField
            onUpload={handleUpload}
            storagePath="content-images"
            currentImage={currentImage?.type === 'upload' ? {
              url: currentImage.uploadUrl,
              caption: currentImage.caption
            } : null}
          />
        )}
      </div>
    </div>
  );
}


